import React from 'react';
import './HowToOrder.css';

const HowToOrder = () => {
  return (
    <div className="how-to-order">
      <header className="order-header">
        <h1>How to Order from UB Resources</h1>
        <p>Simple and flexible ways to get the products you need</p>
      </header>

      <div className="order-steps-container">
        <div className="order-steps">
          <div className="step">
            <div className="step-number">1</div>
            <div className="step-content">
              <h3>Browse Our Catalog</h3>
              <p>Explore our wide range of products. Use filters to easily find what you're looking for.</p>
            </div>
          </div>

          <div className="step">
            <div className="step-number">2</div>
            <div className="step-content">
              <h3>Send Us Your Order List</h3>
              <p>Once you’ve identified the items you need, send us a list via call or email. Our team will respond promptly with a quote.</p>
            </div>
          </div>

          <div className="step">
            <div className="step-number">3</div>
            <div className="step-content">
              <h3>Receive a Quote</h3>
              <p>We will send you a detailed quote with total cost, available quantities, and payment instructions.</p>
            </div>
          </div>

          <div className="step">
            <div className="step-number">4</div>
            <div className="step-content">
              <h3>Make Payment</h3>
              <p>Payments can be made via bank transfer or other accepted local methods (excluding PayPal).</p>
            </div>
          </div>

          <div className="step">
            <div className="step-number">5</div>
            <div className="step-content">
              <h3>Shipping or Pickup</h3>
              <p>Shipping fees depend on your distance from our nearest warehouse. Alternatively, you can pick up directly.</p>
            </div>
          </div>
        </div>

        <div className="order-options">
          <h2>Alternative Order Methods</h2>
          <div className="option-card">
            <div className="option-icon">📞</div>
            <h3>Phone Orders</h3>
            <p>Call us at <a href="tel:+2347031901705">+234 703 190 1705</a> to speak with our sales team directly.</p>
          </div>
          
          <div className="option-card">
            <div className="option-icon">✉️</div>
            <h3>Email Orders</h3>
            <p>Send your order list to <a href="mailto:sales@ubresources.com">sales@ubresources.com</a></p>
          </div>
          
          <div className="option-card">
            <div className="option-icon">🏪</div>
            <h3>Warehouse Pickup</h3>
            <p>Visit us at Building Materials, Ogidi, Anambra, Nigeria to pick up your items in person.</p>
          </div>
        </div>
      </div>

      <div className="faq-section">
        <h2>Ordering FAQs</h2>
        <div className="faq-item">
          <h3>What payment methods do you accept?</h3>
          <p>We accept bank transfers, mobile payments, and local payment options. Please note: we do not accept PayPal.</p>
        </div>
        
        <div className="faq-item">
          <h3>What are your shipping options?</h3>
          <p>Shipping is calculated based on your distance from our nearest warehouse. We’ll provide full details with your quote.</p>
        </div>
        
        <div className="faq-item">
          <h3>Can I modify or cancel my order?</h3>
          <p>You can modify or cancel an order before payment is made. Just call or email us immediately.</p>
        </div>
      </div>

      <div className="contact-prompt">
        <h2>Need Help With Your Order?</h2>
        <p>Our support team is available Monday to Friday, 8am - 5pm</p>
        <div className="contact-buttons">
          <a href="tel:+2347031901705" className="contact-button">Call Us</a>
          <a href="mailto:sales@ubresources.com" className="contact-button">Email Us</a>
          <a href="/contact" className="contact-button">Live Chat</a>
        </div>
      </div>
    </div>
  );
};

export default HowToOrder;
